import { render, staticRenderFns } from "./CrmHeader.vue?vue&type=template&id=d19c2c70&scoped=true&"
import script from "./CrmHeader.vue?vue&type=script&lang=js&"
export * from "./CrmHeader.vue?vue&type=script&lang=js&"
import style0 from "./CrmHeader.vue?vue&type=style&index=0&id=d19c2c70&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19c2c70",
  null
  
)

export default component.exports